import { StringifyOptions } from 'query-string';
import { ReactNode } from 'react';

export enum FILTER_TYPE {
  SELECT = 'select',
  TOGGLE = 'toggle',
  DATE_PICKER = 'date_picker',
  RANGE_DATE_PICKER = 'range_date_picker',
  NUMBER = 'number',
  INPUT_TEXT = 'input_text',
  CHECKBOX = 'checkbox',
  UNCONTROLLABLE_INPUT = 'uncontrollable_input',
  // INPUT_SUGGEST = 'input_suggest', // WIP
}

export type Filter = {
  key?: string;
  label: string;
  name: string;
  rangeDateName?: [string, string];
  dateName?: string;
  formatDate?: string;
  type: FILTER_TYPE;
  apiUrl?: string;
  searchStringify?: StringifyOptions;
  queryStringifyOptions?: StringifyOptions;
  applySingle?: boolean;
  customOptions?: { value: string | number; label: string }[];
  additionalField?: { name: string; label: string };
  constantFilter?: { name: string; value: string };
  onAdditionalFieldClick?: () => void;
  charsAfterComma?: number;
  dependsOn?: string | string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderOption?: (obj: any) => string; // TODO: rnhqq way!!! fix it later
  stopDeb?: boolean;
  customCheckboxValue?: string; // true/false by default
  dropdownRender?: (originNode: React.ReactElement) => React.ReactElement; // for customize your Select
  /**
   * ToggleFilter options. enable false value
   */
  withFalse?: boolean;
  reverseValue?: boolean;
  showSearch?: boolean;
  loadOnEveryOpen?: boolean;
  /** Save filter in LocalStorage option.
   *  It is necessary to specify the same key
   *  for the entire filter block.
   *  EXAMPLE: "DEFECTSPAGE".
   */
  localStorageKey?: string;
  inputPattern?: RegExp;
  allowClear?: boolean;
  tooltip?: {
    text?: string;
    timeout?: number;
  };
  loadOptions?: boolean;
  placeholder?: [string, string] | string;
  width?: number;
  onBlur?: () => void;
  resetIfPreloadEmpty?: boolean;
  step?: number;
  debounceTimeout?: number;
  notReplaceQuery?: boolean;
  /**
   * render extra footer for DATE_PICKER and RANGE_DATE_PICKER
   */
  renderExtraFooter?: () => ReactNode;
  /**
   * related extra filters - will also be deleted by clearAll
   */
  relatedExtraFilterForClear?: string[];
};
